import { render, staticRenderFns } from "./parameters.vue?vue&type=template&id=3472097e&scoped=true"
import script from "./parameters.vue?vue&type=script&lang=js"
export * from "./parameters.vue?vue&type=script&lang=js"
import style0 from "./parameters.vue?vue&type=style&index=0&id=3472097e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472097e",
  null
  
)

export default component.exports